// extracted by mini-css-extract-plugin
export default {"container":"OhDeliveredButton_container__UFgsM"};